import api from './client';

export interface ImpersonationResponse {
  token: string;
  expiresAt: string;
  user: {
    id: number;
    fullName: string;
    role: string;
  };
}

export const impersonationService = {
  start: async (userId: number) =>
    api.post<ImpersonationResponse>('/impersonation', { userId }),
  // Audit-only: records the stop in change_logs; the token itself simply expires.
  stop: async (): Promise<void> => {
    await api.delete('/impersonation');
  },
};
